__turbopack_context__.v({
  "dynamicWidth": "InlineFilters-MeasurementWrapper-module-scss-module__WoVzNq__dynamicWidth",
  "hidden": "InlineFilters-MeasurementWrapper-module-scss-module__WoVzNq__hidden",
  "input": "InlineFilters-MeasurementWrapper-module-scss-module__WoVzNq__input",
  "root": "InlineFilters-MeasurementWrapper-module-scss-module__WoVzNq__root",
});
